import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  chartContainer: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media print': {
      marginBottom: 30,
    },
  },
  chartLegend: { paddingTop: 20 },
}));
